import {authService} from "@/services/AuthService";

export default (to, next, store) => {

    const loggedIn = !!authService.getToken()

    if (loggedIn) {
        return next()
    }

    return next({
        name: 'auth'
    })

}
